import { Injectable } from '@angular/core';
import { DropdownOption } from '../../../../shared/data-types/dropdown-option';
import { CalendarViews } from '../../calendar-types';
import { CalendarInteractionService } from '../../interaction/calendar-interaction.service';

@Injectable()
export class CalendarControlBarService {
  public activeCalendarView: CalendarViews;

  constructor(public calendarInteractionService: CalendarInteractionService) {}

  public getTitle(): string {
    switch (this.activeCalendarView) {
      case CalendarViews.DayGrid:
        return 'Tagesarbeitszeit';
      case CalendarViews.WeekGrid:
        return 'Wochenarbeitszeit';
      case CalendarViews.MonthGrid:
        return 'Monatsarbeitszeit';
      default:
        return '';
    }
  }

  public switchView(option: DropdownOption): void {
    this.activeCalendarView = CalendarViews[CalendarViews[+option.value]];
    this.calendarInteractionService.switchCalendarView(this.activeCalendarView);
  }
}
